import React, {useState,useEffect} from "react";
import './Phone.css';
import ContainPhoneUser  from './ContainPhone/ContainPhoneUser';


export default function PhoneUser(props) {
  const [ID] = useState(props.ID)
  const [CurrentIdName, setCurrentIdName] = useState("")
  const [Contain, setContain] = useState("Profile")

  useEffect(()=>{
    document.getElementById("Profile").style.visibility = "hidden";
    setCurrentIdName("Profile");
  },[])

  const click_ =(id_name)=>{
    document.getElementById(CurrentIdName).style.visibility = "visible";
    document.getElementById(id_name).style.visibility = "hidden";
    setCurrentIdName(id_name);
    setContain(id_name);
  }

  return (
    <div>
        <div className="Phone-title">
          <h1>Playgrounds</h1>
        </div>

        <div className="Phone-quick">

          <div className="Phone-display">
          <div id="Profile_"><h3>Profile</h3><h2>个人信息</h2> </div>
          <div id="Logout_"><h3>Logout</h3><h2>退出</h2> </div>
          <div id="Puzzle_"><h3>Puzzle</h3><h2>华容道</h2></div>
          </div>

          <div className="Phone-button">
          <div id="Profile" onClick={()=>click_("Profile")}><h3>Profile</h3><h2>个人信息</h2> </div>
          <div id="Logout" onClick={()=>click_("Logout")}><h3>Logout</h3><h2>退出</h2> </div>
          <div id="Puzzle" onClick={()=>click_("Puzzle")}><h3>Puzzle</h3><h2>华容道</h2></div>
          </div>

        </div>

        <div className="Phone-contain">
          <ContainPhoneUser 
            ContainInfo = {Contain}
            ID = {ID}/>
        </div>

    </div>
  );
}

